import {createLazyResourceTableUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {CrmSyncModel} from '../../../models/api/crmSyncModel';
import {AppAction} from '../../appActions';
import {deleteFromResourceTable, LazyResourceTable, ResourceTableStatusesEnum} from '../../appTypes';
import {PushStatusActionsEnum} from '../../pushStatus/pushStatusActions';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {CrmSyncActionsEnum} from './crmSyncActions';

const crmSyncsUpdatedReducer = createLazyResourceTableUpdatedReducer('crmSyncs', (crmSync) => crmSync.id);

export function crmSyncsReducer(
  state: LazyResourceTable<number, CrmSyncModel>,
  action: AppAction,
): LazyResourceTable<number, CrmSyncModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return crmSyncsUpdatedReducer(state, action);

    // Push status was marked as disconnected.
    case PushStatusActionsEnum.PUSH_DISCONNECTED:
      return {
        ...state,
        isStale: true,
      };

    case CrmSyncActionsEnum.CRM_SYNC_DELETED:
      return deleteFromResourceTable(state, action.payload);

    case CrmSyncActionsEnum.FETCH_CRM_SYNCS:
      return {
        ...state,
        status: ResourceTableStatusesEnum.LOADING,
        error: undefined,
      };

    case CrmSyncActionsEnum.FETCH_CRM_SYNCS_COMPLETED:
      return {
        ...crmSyncsUpdatedReducer(state, {
          ...action,
          payload: {
            result: {
              crmSyncs: action.payload,
            },
          },
        }),
        status: ResourceTableStatusesEnum.LOADED,
        error: undefined,
        isStale: false,
      };

    case CrmSyncActionsEnum.FETCH_CRM_SYNCS_FAILED:
      return {
        ...state,
        status: ResourceTableStatusesEnum.FAILED,
      };

    default:
      return state;
  }
}
